<template>
  <div class="app-container">
    <div class="header-container">
      <header-vue></header-vue>
    </div>
    <section>
      <transition>
        <keep-alive>
          <router-view :key="key" />
        </keep-alive>
      </transition>
    </section>
    <BacktopBox v-if="!mobile"></BacktopBox>
    <footer-vue class=""></footer-vue>
  </div>
</template>

<script>
import footerVue from '@/views/components/footer.vue';
import headerVue from '../components/header.vue';
import { isMobile } from '@/utils/methods.js';
export default {
  components: {
    footerVue,
    headerVue,
  },
  computed: {
    key() {
      return this.$route.path;
    },
    mobile() {
      return isMobile();
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/styles/variables.less';
.header-container {
  height: @head-height;
  position: relative;
}
</style>




// WEBPACK FOOTER //
// src/views/index/index.vue